
import {
    defineComponent,
    onMounted,
    ref
} from 'vue'

//services
import pservice from '@/core/services/PublicService';
import {
    useRoute
} from 'vue-router';

export default defineComponent({
    name: "public-meetings",
    setup() {
        const loading = ref(false)
        const route = useRoute();
        const {
            idevent,
            idsport
        } = route.params
        const nroFechas = ref(0)
        const selectedFecha = ref<any>('1')
        const evento = ref<any>({})
        const sport = ref<any>({})
        const listMeetings = ref<any>([])

        const getMore = async () => {
            loading.value = true
            await pservice.more({
                evento: idevent,
                sport: idsport
            })
                .then((res) => {
                    loading.value = false
                    evento.value = res.data.event
                    sport.value = res.data.sport
                    getEncuentro()
                    getFechas()
                }).catch(({
                    response
                }) => {
                    loading.value = false
                })
        }

        const getFechas = async () => {
            loading.value = true
            await pservice.getFecha(`idevent=${evento.value.idevent}&idsport=${sport.value.idsport}`)
                .then((res) => {
                    nroFechas.value = res.data.nrofechas
                }).catch(({
                    response
                }) => {
                    loading.value = false
                })

        }

        const getEncuentro = async () => {
            loading.value = true
            await pservice.getMeeting(`idevent=${evento.value.idevent}&idsport=${sport.value.idsport}&nrofecha=${selectedFecha.value}`)
                .then((res) => {
                    loading.value = false
                    listMeetings.value = res.data
                }).catch(({
                    response
                }) => {
                    loading.value = false
                })

        }

        onMounted(() => {
            getMore()

        })

        return {
            loading,
            nroFechas,
            selectedFecha,
            listMeetings,
            getEncuentro,
            getFechas
        }

    },
})
